import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@app/services/user.service';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TokenGuard implements CanActivate {

    constructor(
        private userService: UserService,
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        // Si el usuario no está logueado, permitir acceso (el AuthGuard se encargará)
        if (!this.userService.loggedIn()) {
            return of(true);
        }

        // Verificar token antes de permitir acceso al módulo
        return this.userService.refreshToken().pipe(
            map(() => {
                return true;
            }),
            catchError((error) => {
                console.error('Token verification failed:', error);

                return of(true);
            })
        );
    }
} 